import React from 'react';
import { RichTextElement } from '@kontent-ai/react-components';
import { renderMustacheTemplate } from '../../helpers/content';
import { contentDataSelector } from '../../redux/selectors';
import { useAppSelector } from '../../redux/hooks';
import { validateConditions } from '../../conditions';
import { useErrorNotify } from '../../adapters';
import { useKenticoContentErrorNotify } from '../../kentico/contentErrors';
/**
 * Renders Conditional Rich Text content.
 *
 * Note: this component recursively calls itself as Conditional Rich Text
 * can be embedded inside of other Conditional Rich Text, thanks to Kentico's lovely Rich Text editor
 * features.
 */
export function ConditionalRichText({ contentItem }) {
    const contentData = useAppSelector(contentDataSelector);
    const contentErrorNotify = useKenticoContentErrorNotify();
    if (!validateConditions(contentItem, contentData)) {
        return null;
    }
    const value = renderMustacheTemplate({
        template: contentItem.elements.content.value,
        data: contentData,
        handleError: (message) => contentErrorNotify(message, { contentItem }),
    });
    // Rather then just handing the content as-is to Kentico's RichTextElement component, first we
    // are going to evaluate the mustache
    const evaluatedContent = {
        ...contentItem.elements.content,
        value,
    };
    return (React.createElement(RichTextElement, { richTextElement: evaluatedContent, resolvers: {
            resolveLinkedItem: (linkedItem) => isConditionalRichText(linkedItem) ||
                isDetailsPageContent(linkedItem) ? (React.createElement(ConditionalRichText, { contentItem: linkedItem })) : (React.createElement(IgnoredContent, { contentItem: linkedItem })),
        } }));
}
/**
 * Component meant to be used inside of Kentico's RichTextElement for situations where the content in
 * the CMS doesn't align with what the code expects.
 */
function IgnoredContent({ contentItem }) {
    const errorNotify = useErrorNotify();
    errorNotify('Recieved unexpected content while rendering Details Page Content, this will be omitted:\n' +
        JSON.stringify(contentItem));
    // Kentico's RichTextElement needs this to effectively skip this piece of linked content
    return React.createElement(React.Fragment, null);
}
// I cannot figure out how to use Kentico types in a discriminated union, so I have to write
// these type assertions.  If you can figure out how to do that, then this type assertion can
// go away!
function isConditionalRichText(value) {
    return value?.system.type === 'conditional_rich_text';
}
function isDetailsPageContent(value) {
    return value?.system.type === 'details_page_content';
}
//# sourceMappingURL=ConditionalRichText.js.map